import React from "react";
import { Tooltip } from "@material-ui/core";

export default function OptimizedTooltip({ PopperProps, ...props }) {
  return (
    <Tooltip
      PopperProps={{
        container: document.getElementById("tooltip-wrapper"),
        ...PopperProps
      }}
      {...props}
    />
  );
}
